import { useAppDispatch } from '~/redux/hooks'
import { useUpdateSettings } from '~/settings-scenario/hooks'

import useCurrentUser from '~/hooks/useCurrentUser'
import { Tab } from '~/settings-scenario'

import {
  closeCurriculumDropdownsActionCreator,
  setCurriculumChangeLoadingActionCreator,
  setCurriculumChangeWarningActionCreator,
} from '../slice/curriculum.slice'
import { useResetGradesMutation } from '../apis/curriculum.api'

import { setLockRedirectionActionCreator } from '../slice/redirection.slice'

import useHandleRedirectionOnChange from './useHandleRedirectionOnChange'

export const useCurriculumChange = (isOnboarding?: boolean) => {
  const dispatch = useAppDispatch()
  const handleOnSubmit = useUpdateSettings()
  const [resetGrades] = useResetGradesMutation()
  const user = useCurrentUser()
  const handleRedirection = useHandleRedirectionOnChange(isOnboarding)

  const cancelOnClick = (): void => {
    dispatch(setCurriculumChangeWarningActionCreator(false))
  }

  const handleConfirmSelect = async (): Promise<void> => {
    // To avoid the redirection from https://github.com/houseofmath/hom-frontend/blob/3caf7c8347a6d543e9aa85edcec17667fa6f9d12/pages/_app.tsx#L61
    dispatch(setLockRedirectionActionCreator(true))

    dispatch(setCurriculumChangeLoadingActionCreator(true))

    if (user?.id) {
      const resetGradeSuccess = await resetGrades()
      if (!resetGradeSuccess?.data?.success) {
        dispatch(setCurriculumChangeLoadingActionCreator(false))
        // No navigation happens on this path, so nothing else would release the lock.
        dispatch(setLockRedirectionActionCreator(false))
        return
      }

      await handleOnSubmit(Tab.CURRICULUM)
    }

    dispatch(setCurriculumChangeLoadingActionCreator(false))
    dispatch(closeCurriculumDropdownsActionCreator())
    cancelOnClick()

    await handleRedirection()
  }

  return { handleConfirmSelect, cancelOnClick }
}
